import React from 'react';
import useConsentCheck from 'hooks/use-consent-check';
import useClient from 'hooks/use-client';
import ErrorCookiesSettings from '../error-cookies-settings/error-cookies-settings';
import Delay from '../delay/delay';

const YoutubeIframe = ({
  uniquePrefix,
  isMobile = false,
  videoMobile,
  paddingClass = 'aspect-video',
  videoId,
  nativeControls,
  autoplay = false,
  consentCode,
  errorText,
}) => {
  const isConsentGranted = useConsentCheck(consentCode);
  const isClient = useClient();

  let classStyles = 'relative';
  if (!isMobile) {
    if (videoMobile.length > 0) {
      classStyles += ' hidden md:flex';
    }
  } else {
    classStyles += ' md:hidden';
  }
  classStyles += ` ${paddingClass}`;

  const elementId = `video-${uniquePrefix}-${videoId}${isMobile ? '-mobile' : ''}`;
  return (
    <div>
      {isClient && !isConsentGranted && (
        <Delay waitTime={500}>
          <div className={classStyles}>
            <ErrorCookiesSettings errorText={errorText} />
          </div>
        </Delay>
      )}
      {isConsentGranted && (
        <div className={classStyles}>
          <iframe
            id={elementId}
            src={`https://www.youtube.com/embed/${videoId}?title=0&fs=0&rel=0&${
              nativeControls ? 'controls=1' : 'controls=0'
            }${autoplay ? '&autoplay=1&autopause=0&loop=1' : '&byline=0&autopause=0&portrait=0'}`}
            allow={`${autoplay ? 'autoplay; ' : ''}encrypted-media; picture-in-picture`}
            className="absolute left-0 top-0 h-full w-full"
            title="youtube Video Player"
            data-dom-player
          ></iframe>
        </div>
      )}
    </div>
  );
};

export default YoutubeIframe;
